import { useTranslations } from 'next-intl'

import {
  useSignUpGuestStore,
  useValidateStep,
  createZGuestInfoForm,
  TGuestInfoForm,
  TTermsForm,
} from '@/features/sign-up'

const GUEST_STEP_PATHS: Record<string, number> = {
  intro: 0,
  terms: 1,
  info: 2,
  verification: 3,
  complete: 4,
}

const validateTermsStep = (terms: TTermsForm) => {
  const isRequiredAllChecked =
    terms.termsOfService && terms.privacyConsent && terms.ageOver19

  return isRequiredAllChecked
}

const validateGuestInfoStep = (
  info: TGuestInfoForm,
  t: ReturnType<typeof useTranslations<'account'>>,
) => {
  const { success } = createZGuestInfoForm(t).safeParse(info)

  return success
}

export const useValidateGuestStep = () => {
  const { terms, info } = useSignUpGuestStore()
  const t = useTranslations('account')

  useValidateStep(GUEST_STEP_PATHS, [
    {
      step: 2,
      validate: () => validateTermsStep(terms),
      redirect: `/sign-up/guest?step=terms`,
    },
    {
      step: 3,
      validate: () => validateGuestInfoStep(info, t),
      redirect: `/sign-up/guest?step=info`,
    },
  ])
}
